module.exports = __webpack_public_path__ + "assets/img/Ober_poster_video.dd58903a.png";